import { render, staticRenderFns } from "./DeleteArtist.vue?vue&type=template&id=0753fe56&scoped=true&"
import script from "./DeleteArtist.vue?vue&type=script&lang=js&"
export * from "./DeleteArtist.vue?vue&type=script&lang=js&"
import style0 from "./DeleteArtist.vue?vue&type=style&index=0&id=0753fe56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753fe56",
  null
  
)

export default component.exports